import { motion } from 'framer-motion';
import Container from '../components/ui/Container';
import GroupSection from '../components/subsidiaries/GroupSection';

const groups = [
  {
    name: "Bilbos Group",
    logo: "https://res.cloudinary.com/dg14vitlg/image/upload/v1740414748/BILBOS_GROUP_odari6.jpg",
    description: "Driving growth in travel and tourism, marketing, exports and other general business endeavors.",
    subsidiaries: [
      "UGOGO Travel Konsult Services",
      "Bilbos Export & Construction",
      "InvestDrive Ghana Limited",
      "BrandEcho Africa",
      "All my Needs Impex",
      "Mawimbi Ghana Limited"
    ]
  },
  {
    name: "Ngoli Group",
    logo: "https://res.cloudinary.com/dg14vitlg/image/upload/v1740414748/NGOLI_Group_White_BG_Portrait_vcjgul.png",
    description: "Providing cutting-edge solutions in business consulting, asset management, legal protection, and financial services.",
    subsidiaries: [
      "Ngoli Consult Limited",
      "Vertex Legal Protection Limited",
      "Ngoli Capital Partners Limited",
      "Prestige Insurance Brokers",
      "Arakan Energy Limited",
      "Black Gold Haulage"
    ]
  },
  {
    name: "Coastline Developers Group",
    logo: "https://res.cloudinary.com/dg14vitlg/image/upload/v1740414739/IMG_6891_uflmll.jpg",
    description: "Fueling sustainable growth in infrastructure, construction and real estate development.",
    subsidiaries: [
      "Alpha Homes and Construction",
      "Blue Arc Ventures"
    ]
  }
];

export default function Subsidiaries() {
  return (
    <div className="bg-white">
      <section className="relative h-[300px] overflow-hidden">
        <motion.div
          initial={{ scale: 1.1, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
          className="absolute inset-0"
        >
          <img
            src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=2000&q=80"
            alt="Modern business district"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/70" />
        </motion.div>
        
        <Container className="relative h-full flex items-center justify-center text-center">
          <div>
            <motion.h1 
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              className="text-4xl md:text-5xl font-bold text-white mb-4"
            >
              Our Companies
            </motion.h1>
            <motion.p 
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.7 }}
              className="text-xl text-white/90 max-w-2xl mx-auto"
            >
              Discover our diverse portfolio of industry-leading subsidiaries
            </motion.p>
          </div>
        </Container>
      </section>

      <section className="py-16">
        <Container>
          <div className="space-y-8">
            {groups.map((group) => (
              <GroupSection key={group.name} {...group} />
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}